import { FormModalContent, FormModalTopBar } from '@upright/ui/common/generic/modals/form-modal/form-modal-parts';
import styled from 'styled-components';
import { SubscriptionTable } from '../../subscription-table';

export const SubscriptionTiersModalPage = () => {
  return (
    <>
      <FormModalTopBar>
        <h1>Choose your plan</h1>
      </FormModalTopBar>
      <StyledFormModalContent>
        <SubscriptionTable layout="tight" />
      </StyledFormModalContent>
    </>
  );
};

const StyledFormModalContent = styled(FormModalContent)`
  max-height: fit-content;
  margin-bottom: 2em;
`;
